import * as Sentry from "@sentry/nextjs"
import {
  isAfter,
  isBefore,
  isSameDay,
  isWithinInterval,
  subDays,
  subMonths
} from "date-fns"

export const applyDateRangeFilter = (
  rows: any[],
  dateRangeOption: string | null,
  startDate: Date | null,
  endDate: Date | null
) => {
  const today = new Date()
  let filteredRows = rows

  try {
    switch (dateRangeOption) {
      case "Last 5 days": {
        const fiveDaysAgo = subDays(today, 5)
        filteredRows = rows.filter((row) => {
          const rowDate = row.parsedDate
          return (
            rowDate && isAfter(rowDate, fiveDaysAgo) && isBefore(rowDate, today)
          )
        })
        break
      }
      case "1month": {
        const oneMonthAgo = subMonths(today, 1)
        filteredRows = rows.filter((row) => {
          const rowDate = row.parsedDate
          return (
            rowDate && isAfter(rowDate, oneMonthAgo) && isBefore(rowDate, today)
          )
        })
        break
      }
      case "YTD": {
        const startOfYear = new Date(today.getFullYear(), 0, 1)
        filteredRows = rows.filter((row) => {
          const rowDate = row.parsedDate
          return (
            rowDate && isAfter(rowDate, startOfYear) && isBefore(rowDate, today)
          )
        })
        break
      }
      case "6months": {
        const sixMonthsAgo = subMonths(today, 6)
        filteredRows = rows.filter((row) => {
          const rowDate = row.parsedDate
          return (
            rowDate &&
            isAfter(rowDate, sixMonthsAgo) &&
            isBefore(rowDate, today)
          )
        })
        break
      }
      case "Between": {
        if (startDate && endDate) {
          if (isBefore(endDate, startDate)) {
            ;[startDate, endDate] = [endDate, startDate]
          }
          filteredRows = rows.filter((row) => {
            const rowDate = row.parsedDate
            return (
              rowDate &&
              isWithinInterval(rowDate, {
                start: startDate as Date,
                end: endDate as Date
              })
            )
          })
        }
        break
      }
      case "Before": {
        if (startDate) {
          filteredRows = rows.filter((row) => {
            const rowDate = row.parsedDate
            return rowDate && isBefore(rowDate, startDate as Date)
          })
        }
        break
      }
      case "After": {
        if (startDate) {
          filteredRows = rows.filter((row) => {
            const rowDate = row.parsedDate
            return rowDate && isAfter(rowDate, startDate as Date)
          })
        }
        break
      }
      case "On": {
        if (startDate) {
          filteredRows = rows.filter((row) => {
            const rowDate = row.parsedDate
            return rowDate && isSameDay(rowDate, startDate as Date)
          })
        }
        break
      }
      default:
        break
    }
  } catch (error) {
    Sentry.captureException(error)
  }

  return filteredRows
}
